import React from 'react';

const FIELD_LABELS = [
  ['dateOfAgreement', 'Date of Agreement'],
  ['domesticStocks', 'Domestic Stocks or Domestic Stock Funds'],
  ['internationalStocks', 'International Stocks or International Stock Funds'],
  ['bonds', 'Bonds (Bonds, Bond Funds, Muni Bonds, Govt Treasuries, CDs, etc.)'],
  ['alternativeInvestments', 'Alternative Investments (Real estate, Commodity Funds, Allocation Funds, etc.)'],
  ['moneyMarket', 'Money Market'],
  ['concentrationPositions', 'Concentration Positions'],
  ['otherLanguage', 'Other Unique Language'],
];

const FIELD_GROUPS = [
  [FIELD_LABELS[0], FIELD_LABELS[1]],
  [FIELD_LABELS[2], FIELD_LABELS[3]],
  [FIELD_LABELS[4], FIELD_LABELS[5]],
  [FIELD_LABELS[6], FIELD_LABELS[7]],
];

/**
 * IpsFileAnalysisPanel
 *
 * Renders the Bedrock-extracted IPS fields for a single file, or a
 * pending/analyzing/error state while the background analysis is running.
 */
const IpsFileAnalysisPanel = ({ analysis }) => {
  if (!analysis) {
    return null;
  }

  if (analysis.status === 'pending' || analysis.status === 'analyzing') {
    return (
      <div className="small text-muted mt-2">
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Analyzing document for IPS details...
      </div>
    );
  }

  if (analysis.status === 'error') {
    return (
      <div className="small text-danger mt-2">
        <i className="bi bi-exclamation-triangle me-1"></i>
        Analysis failed: {analysis.error || 'Unknown error'}
        {analysis.rawResponse && (
          <details className="mt-1">
            <summary className="text-muted" style={{ cursor: 'pointer' }}>Show raw analysis response</summary>
            <pre className="small text-muted mt-1 mb-0" style={{ whiteSpace: 'pre-wrap' }}>
              {analysis.rawResponse}
            </pre>
          </details>
        )}
      </div>
    );
  }

  const fields = analysis.fields || {};
  const formatFieldValue = (value) => {
    if (Array.isArray(value)) {
      const cleaned = value
        .map((item) => String(item || '').trim())
        .filter(Boolean);
      return cleaned.length ? cleaned.join(', ') : null;
    }
    return value;
  };

  // When the LLM confirmed this is not an IPS, show an informational note
  // instead of the field-extraction table.
  if (fields.isIps === false) {
    return (
      <div className="small text-muted mt-2">
        <i className="bi bi-info-circle me-1"></i>
        This file was not identified as an Investment Policy Statement.
      </div>
    );
  }

  return (
    <table className="table table-sm table-bordered mb-0 mt-2 align-middle w-100">
      <tbody>
        {FIELD_GROUPS.map((group, idx) => {
          const [leftField, rightField] = group;
          const [leftKey, leftLabel] = leftField;
          const [rightKey, rightLabel] = rightField;

          return (
            <tr key={`${leftKey}-${rightKey}-${idx}`}>
              <th className="small text-muted bg-light" style={{ width: '22%' }}>{leftLabel}</th>
              <td className="small" style={{ width: '28%' }}>
                {formatFieldValue(fields[leftKey]) || <span className="text-muted">—</span>}
              </td>
              <th className="small text-muted bg-light" style={{ width: '22%' }}>{rightLabel}</th>
              <td className="small" style={{ width: '28%' }}>
                {formatFieldValue(fields[rightKey]) || <span className="text-muted">—</span>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default IpsFileAnalysisPanel;
